import React from 'react';
import { process } from '../data/process';
import { SectionHeading } from './SectionHeading';
export function Process() {
  return <section className="bg-bone py-16 lg:py-24" data-id="element-179" data-mp="1uc22rl6ojypv">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-180" data-mp="1yfgkqhe6ip5y">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-181" data-mp="1yg01vvw099ix">
          <div data-id="element-182" data-mp="23d0aadgbuod7">
            <SectionHeading title="Comment se passe une intervention" intro="Quatre étapes, toujours dans le même ordre. Vous savez à l’avance ce qui va se passer et ce que vous allez payer." data-id="element-183" data-mp="23drwwyry5brc" />
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/3357868a-d70c-40f2-bb93-d09b308e71ea.jpg" alt="Établi de serrurier avec clés en laiton, cylindres démontés et outils de précision" className="mt-8 hidden h-64 w-full rounded-sm object-cover lg:block" data-id="element-184" data-mp="1fopgtvcynqyy" />
          </div>

          <ol className="relative border-l border-bone-dark" data-id="element-185" data-mp="rxtql2o5l3tt">
            {process.map((step, index) => <li key={step.title} className="relative pb-10 pl-8 last:pb-0" data-id="element-186" data-mp="19kpryx3ido5g" data-mpi={index}>
                <span className="absolute -left-[13px] top-0 flex h-[26px] w-[26px] items-center justify-center rounded-full bg-ink-900 font-display text-xs font-bold text-brass-light" aria-hidden="true" data-id="element-187" data-mp="15kp30iis9uk5">
                  {index + 1}
                </span>
                <h3 className="font-display text-lg font-bold text-ink-900" data-id="element-188" data-mp="qvj3sujy44c9">{step.title}</h3>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-ink-600" data-id="element-189" data-mp="luveqefa1xko">
                  {step.description}
                </p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}